/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FTTicketActionTemplateCreateSchema } from '../models/FTTicketActionTemplateCreateSchema';
import type { FTTicketActionTemplateDetailSchema } from '../models/FTTicketActionTemplateDetailSchema';
import type { FTTicketActionTemplateUpdateSchema } from '../models/FTTicketActionTemplateUpdateSchema';
import type { InsuranceActionTemplateType } from '../models/InsuranceActionTemplateType';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FtTicketTemplateApi {
    /**
     * List Ft Tickets Template
     * Get FT ticket templates list, <br>Required Permission: get_ft_ticket_template_list
     * @returns FTTicketActionTemplateDetailSchema OK
     * @throws ApiError
     */
    public static insuranceListFtTicketsTemplateGet({
        templateType,
    }: {
        templateType?: (InsuranceActionTemplateType | null),
    }): CancelablePromise<Array<FTTicketActionTemplateDetailSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/ft-ticket-template/',
            query: {
                'template_type': templateType,
            },
        });
    }
    /**
     * Create Ft Ticket Template
     * Create new FT ticket template, <br>Required Permission: create_ft_ticket_template
     * @returns FTTicketActionTemplateDetailSchema Created
     * @throws ApiError
     */
    public static insuranceCreateFtTicketTemplatePost({
        requestBody,
    }: {
        requestBody: FTTicketActionTemplateCreateSchema,
    }): CancelablePromise<FTTicketActionTemplateDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/ft-ticket-template/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Detail Ft Ticket Template
     * Get FT ticket template detail, <br>Required Permission: get_ft_ticket_template_detail
     * @returns FTTicketActionTemplateDetailSchema OK
     * @throws ApiError
     */
    public static insuranceDetailFtTicketTemplateGet({
        ftTicketTemplateId,
    }: {
        ftTicketTemplateId: string,
    }): CancelablePromise<FTTicketActionTemplateDetailSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/ft-ticket-template/{ft_ticket_template_id}/',
            path: {
                'ft_ticket_template_id': ftTicketTemplateId,
            },
        });
    }
    /**
     * Delete Ft Ticket Template
     * Delete FT ticket template. <br>Required Permission: remove_ft_ticket_template
     * @returns void
     * @throws ApiError
     */
    public static insuranceDeleteFtTicketTemplateDelete({
        ftTicketTemplateId,
    }: {
        ftTicketTemplateId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/ft-ticket-template/{ft_ticket_template_id}/',
            path: {
                'ft_ticket_template_id': ftTicketTemplateId,
            },
        });
    }
    /**
     * Update Ft Ticket Template
     * Update FT ticket template, <br>Required Permission: update_ft_ticket_template
     * @returns FTTicketActionTemplateDetailSchema OK
     * @throws ApiError
     */
    public static insuranceUpdateFtTicketTemplatePut({
        ftTicketTemplateId,
        requestBody,
    }: {
        ftTicketTemplateId: string,
        requestBody: FTTicketActionTemplateUpdateSchema,
    }): CancelablePromise<FTTicketActionTemplateDetailSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/ft-ticket-template/{ft_ticket_template_id}/',
            path: {
                'ft_ticket_template_id': ftTicketTemplateId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
